'use client';

import { useSyncExternalStore } from 'react';

import { screens } from '../theme';

type Breakpoint = `${'' | 'max-'}${'sm' | 'md' | 'lg' | 'xl'}`;

const BREAKPOINTS = /* @__PURE__ */ (() => ({
  sm: parseInt(screens.sm),
  md: parseInt(screens.md),
  lg: parseInt(screens.lg),
  xl: parseInt(screens.xl),
}))();

const getWidth = () => window.innerWidth;

const subscribeResize = (callback: () => void) => {
  window.addEventListener('resize', callback);
  return () => {
    window.removeEventListener('resize', callback);
  };
};

const SERVER_WIDTH = Number.MAX_SAFE_INTEGER;

const useBreakpoint = (breakpoint: Breakpoint) => {
  const width = useSyncExternalStore(subscribeResize, getWidth, () => SERVER_WIDTH);
  const isMax = breakpoint.startsWith('max-');

  if (isMax) {
    const maxBreakpoint = breakpoint.replace('max-', '') as keyof typeof BREAKPOINTS;
    return width < BREAKPOINTS[maxBreakpoint];
  }

  return width >= BREAKPOINTS[breakpoint as keyof typeof BREAKPOINTS];
};

export { useBreakpoint };
